import React from 'react';
import { contactContent } from '@/content/contact';
import ContactDetails from './ContactDetails.tsx';
import ContactForm from './ContactForm.tsx';
import { Section } from '@/components/ui';

const ContactUs: React.FC = () => {
    return (
        <Section
            id="contact"
            className="contact-section"
            title={contactContent.sectionTitle}
            titleClassName="contact-title"
        >
            <div className="contact-container">
                <ContactDetails />
                <ContactForm />
            </div>
        </Section>
    );
};

export default ContactUs;
